import { z } from "zod";

/** GitHub account kind + repo-access selection, mirrored from the service types. */
const githubAccountTypeSchema = z.enum(["Organization", "User"]);
const githubRepositorySelectionSchema = z.enum(["all", "selected"]);

/**
 * A team's GitHub App connection status (`githubIntegration.getInstallation`).
 * All identity fields are null when `connected` is false. `repositoriesSyncedAt`
 * / `installedAt` are `Date` objects (Drizzle timestamps passed through).
 */
export const githubConnectionStatusSchema = z.object({
  connected: z.boolean(),
  installationId: z.string().nullable(),
  githubInstallationId: z.string().nullable(),
  accountLogin: z.string().nullable(),
  accountType: githubAccountTypeSchema.nullable(),
  accountAvatarUrl: z.string().nullable(),
  repositorySelection: githubRepositorySelectionSchema.nullable(),
  repositoryCount: z.number(),
  repositoriesSyncedAt: z.date().nullable(),
  installedAt: z.date().nullable(),
});

/** One selectable GitHub installation (`githubIntegration.getInstallationSelection`). */
export const githubInstallationSelectionOptionSchema = z.object({
  githubInstallationId: z.string(),
  accountLogin: z.string(),
  accountType: githubAccountTypeSchema,
  accountAvatarUrl: z.string().nullable(),
  repositorySelection: githubRepositorySelectionSchema,
});

/** One synced repository (`githubIntegration.listRepositories`). `syncedAt` is a Date. */
export const githubRepositorySummarySchema = z.object({
  id: z.string(),
  githubRepoId: z.string(),
  owner: z.string(),
  name: z.string(),
  fullName: z.string(),
  private: z.boolean(),
  archived: z.boolean(),
  defaultBranch: z.string(),
  syncedAt: z.date(),
});

/** One branch from the live GitHub API (`githubIntegration.listBranches`). */
export const githubBranchSummarySchema = z.object({
  name: z.string(),
  commitSha: z.string(),
});
